/* global axios */
import ApiClient from './ApiClient';

class SegmentsAPI extends ApiClient {
  constructor() {
    super('segments', { accountScoped: true });
  }

  getMembers(segmentId, page = 1) {
    return axios.get(`${this.url}/${segmentId}/members?page=${page}`);
  }

  getContactSegments(contactId) {
    return axios.get(
      `${this.url.replace('/segments', '')}/contacts/${contactId}/segments`
    );
  }

  exportMembers(segmentId) {
    return axios.get(`${this.url}/${segmentId}/export_members`, {
      responseType: 'blob',
    });
  }
}

export default new SegmentsAPI();
